import React from 'react';
import { HeroBackground } from './HeroBackground';
export function Hero() {
  return <section className="relative w-full py-20 md:py-28 lg:py-36 px-4 overflow-hidden" data-id="element-92">
      <HeroBackground data-id="element-93" />

      <div className="container max-w-6xl mx-auto relative z-10" data-id="element-94">
        <div className="flex flex-col items-center text-center space-y-8" data-id="element-95">
          {/* WisePilot mark only */}
          <div className="w-24 h-24 md:w-32 md:h-32" data-id="element-96">
            <img src="https://cdn.magicpatterns.com/uploads/o747JZpJ7gAXEA68q9Ekrm/wisepilot-mark.png" alt="WisePilot" className="w-full h-full object-contain" data-id="element-97" />
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground max-w-5xl leading-tight" data-id="element-98">
            The Autonomous Content & Marketing Engine for Revenue Teams
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-4xl leading-relaxed" data-id="element-99">
            WisePilot replaces fragmented content, prompts, publishing, and
            reporting with a governed AI system that compounds performance
            across SEO, CRM, and GTM execution.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 items-center justify-center w-full sm:w-auto" data-id="element-100">
            <a href="#" className="inline-flex items-center justify-center rounded-lg px-8 py-3 text-base font-semibold text-white bg-[hsl(var(--brand-blue-light))] hover:bg-[hsl(216,71%,40%)] dark:bg-[hsl(var(--brand-blue-dark))] dark:hover:bg-[hsl(214,100%,65%)] transition-colors w-full sm:w-auto" aria-label="Book a Demo" data-id="element-101">
              Book a Demo
            </a>
            <a href="#" className="inline-flex items-center justify-center rounded-lg px-8 py-3 text-base font-semibold text-foreground bg-transparent border-2 border-border hover:bg-muted transition-colors w-full sm:w-auto" aria-label="See the System" data-id="element-102">
              See the System
            </a>
          </div>

          {/* Authority Line */}
          <p className="text-sm md:text-base text-muted-foreground max-w-3xl pt-4 leading-relaxed" data-id="element-103">
            Built for agencies and marketing teams running content as
            infrastructure — not as a side task.
          </p>
        </div>
      </div>
    </section>;
}